import React from 'react'
import { ButtonDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

export default class ItemMenu extends React.Component {
  constructor(props){
    super(props)
    this.state = {open: false}
  }

  toggle = () => this.setState({open: !this.state.open})
  render(){
    return(
      <ButtonDropdown isOpen={this.state.open} toggle={this.toggle} direction='left'>
        <DropdownToggle size='sm' tag='span'>
          <i className="fas fa-ellipsis-v"/>
        </DropdownToggle>
        <DropdownMenu>
          {this.props.children}
        </DropdownMenu>
      </ButtonDropdown>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ItemMenu.js